import { Form, Select } from 'antd';

import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { useEditoDaytimePacks } from 'app/hooks/data/core/admin/packs/useEditoDaytimePacks';
import { buildDaytimePackValue } from 'app/utils/edito';
import { formatHotelNameWithStars } from 'app/utils/hotels';
import { requiredRule } from 'app/utils/rules';

import { HeaderWrapper } from '../../../../HeaderWrapper/HeaderWrapper';

const { Option } = Select;

type Props = {
  fieldName: string | number;
};

export const DaytimePackRedirectionForm = ({ fieldName }: Props) => {
  const { data: packs } = useEditoDaytimePacks();

  return (
    <div className="actionContainer">
      <div className="arrow" />
      <HeaderWrapper title="Daytime package">
        <Form.Item
          name={[fieldName, 'daytimePackValue']}
          rules={[requiredRule]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            placeholder="Select a daytime package from the list"
            filterOption={(input, option) =>
              option?.props.key
                .toLowerCase()
                .toString()
                .includes(input.toLowerCase())
            }
          >
            {packs?.map((pack) => {
              const packValue = buildDaytimePackValue(pack);

              return (
                <Option
                  key={`${pack.hotelName}-${pack.name}-${packValue}`}
                  value={packValue}
                  className="select-item__option"
                >
                  <div className="select-item__wrapper">
                    <div className="select-item__thumbnail">
                      <PictureComponent pictureId={pack.cover?.path ?? ''} />
                    </div>
                    <div className="select-item__name">
                      {`${pack.name} • ${formatHotelNameWithStars(
                        pack.hotelName,
                        pack.hotelStars
                      )}`}
                    </div>
                  </div>
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </HeaderWrapper>
    </div>
  );
};
